import { format } from "date-fns";
import defaultStrategy from "./default.js";

export default {
  buildBookingUrl({ site, arrivalDate }) {
    const url = new URL(site.reserveUrl);
    // Old catalog rows remain usable until the deployed refresh converges.
    if (url.hostname !== "widget.cowlendar.com") return site.reserveUrl;
    url.searchParams.set("date", format(arrivalDate, "yyyy-MM-dd"));
    return url.href;
  },
  buildPreviewUrl() {
    return "https://melanzana.com/pages/book-an-appointment";
  },
  describeBookingInputs() {
    const { inputs } = defaultStrategy.describeBookingInputs();
    return {
      inputs: {
        ...inputs,
        arrivalDate: {
          status: "required",
          notes:
            "Selects the appointment day; choose the matching time on the calendar.",
        },
        departureDate: {
          status: "ignored",
          notes: "Appointments have a fixed 30-minute duration.",
        },
        ref: {
          status: "ignored",
          notes: "The provider cannot preselect a time slot by URL.",
        },
        partySize: {
          status: "ignored",
          defaultValue: 1,
          notes:
            "Book one appointment per person; remaining capacity does not change the URL quantity.",
        },
      },
    };
  },
};
